import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Import = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 1.5L8.5 8.79289L10.1464 7.14645C10.3417 6.95118 10.6583 6.95118 10.8536 7.14645C11.0488 7.34171 11.0488 7.65829 10.8536 7.85355L8.35355 10.3536C8.25669 10.4504 8.12996 10.4992 8.003 10.5L8 10.5L7.997 10.5C7.9303 10.4996 7.86669 10.4861 7.80861 10.4621C7.74964 10.4377 7.69439 10.4015 7.64645 10.3536L5.14645 7.85355C4.95118 7.65829 4.95118 7.34171 5.14645 7.14645C5.34171 6.95118 5.65829 6.95118 5.85355 7.14645L7.5 8.79289L7.5 1.5C7.5 1.22386 7.72386 1 8 1C8.27614 1 8.5 1.22386 8.5 1.5ZM3.5 4.5C2.39543 4.5 1.5 5.39543 1.5 6.5V11.5C1.5 12.6046 2.39543 13.5 3.5 13.5H12.5C13.6046 13.5 14.5 12.6046 14.5 11.5V6.5C14.5 5.39543 13.6046 4.5 12.5 4.5H11.4286C11.1524 4.5 10.9286 4.72386 10.9286 5C10.9286 5.27614 11.1524 5.5 11.4286 5.5H12.5C13.0523 5.5 13.5 5.94772 13.5 6.5V11.5C13.5 12.0523 13.0523 12.5 12.5 12.5H3.5C2.94772 12.5 2.5 12.0523 2.5 11.5V6.5C2.5 5.94772 2.94772 5.5 3.5 5.5H4.57143C4.84757 5.5 5.07143 5.27614 5.07143 5C5.07143 4.72386 4.84757 4.5 4.57143 4.5H3.5Z"
        fill={color}
      />
    </svg>
  )
})

export default Import
